import { render, staticRenderFns } from "./Major.vue?vue&type=template&id=46c4efcd&scoped=true"
import script from "./Major.vue?vue&type=script&lang=js"
export * from "./Major.vue?vue&type=script&lang=js"
import style0 from "./Major.vue?vue&type=style&index=0&id=46c4efcd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c4efcd",
  null
  
)

export default component.exports